import React from "react";
import PropTypes from "prop-types";

// components
import CaretDown from "core/ReusableIcons/CaretDown";

// styles
import { ControlStyled } from "./styles";

// component
export const Control = ({ title, isOpen, toggleIsOpen, iconSize }) => {
    return (
        <ControlStyled onClick={toggleIsOpen} $isOpen={isOpen}>
            <span>{title}</span>
            <CaretDown size={{ width: iconSize, height: iconSize }} />
        </ControlStyled>
    );
};

export default Control;

// prop-types
Control.propTypes = {
    title: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggleIsOpen: PropTypes.func.isRequired,
    iconSize: PropTypes.number.isRequired
};
